import bg from '../assets/bg.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import gallery05 from '../assets/gallery05.png';
import menu from '../assets/menu.png';
import welcome from '../assets/welcome.png';
import bubblelab from '../assets/bubblelab.png';
import lab from '../assets/lab.png';
import bubbles from '../assets/bubbles.png'
import drink from '../assets/drink.png'

export default {
  bg,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  menu,
  welcome,
  bubblelab,
  lab,
  bubbles,
  drink,
};
